import { render, staticRenderFns } from "./DeleteExpiredPickls.vue?vue&type=template&id=714c9ec7&scoped=true&"
import script from "./DeleteExpiredPickls.vue?vue&type=script&lang=ts&"
export * from "./DeleteExpiredPickls.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteExpiredPickls.vue?vue&type=style&index=0&id=714c9ec7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714c9ec7",
  null
  
)

export default component.exports